import { lazy, Suspense } from "react";
import { Header, Footer } from "./components/Navigation";
import { Route, Routes, useLocation } from "react-router-dom";

const Gallery = lazy(() => import("./components/Gallery.js"));
const About = lazy(() => import("./components/About.js"));
const Media = lazy(() => import("./components/Media.js"));
const ProjectDetail = lazy(() => import("./components/Project.js"));

function AnimatedRoutes() {
  const location = useLocation();

  return (
    <Suspense fallback={null}>
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Gallery />} />
        <Route path="/work/:slug" element={<ProjectDetail />} />
        <Route path="/about" element={<About />} />
        <Route path="/media" element={<Media />} />
      </Routes>
    </Suspense>
  );
}

function App() {
  return (
    <>
      <Header />
      <AnimatedRoutes />
      <Footer />
    </>
  );
}

export default App;
